import React from "react";

const SolutionContentCard = (props) => {
    return (
        <>
            {props.type === "text" ? (
                <div style={{ marginTop: "1%", fontSize: "large" }}>{props.content}</div>
            ) : (
                <div className="justify-center items-center my-10">
                    <div className="h-full flex">
                        <img src={props.content} className="rounded-lg w-[100%]" alt="Subject Image" />
                    </div>
                </div>
            )}
        </>
    );
};
export default SolutionContentCard;
